import React, { useEffect, useState } from "react";
import {
  ITabDetail,
  Tabcontroller,
} from "../../../../core/components/tab-controller/tab-controller";
import { AddNoteActivity } from "./add-note-activity";
import { AddFileActivity } from "./add-file-activity";
import api from "../../../../api";
import { PlannedActivities } from "./planned-activities";
import { DoneActivities } from "./done-activities";
import {
  useHasPermission,
  AppPermissions,
  ILeadActivity,
  PaginatedApiResponse,
  getNearestFutureTime,
  DateFormats,
} from "../../../../core";
import { AddActivityWraper } from "./add-activity";
import { useDataLoader } from "react-remote-data-hooks";
import moment from 'moment';
import { LeadRequirement } from "../../../../core/api/models/requirement";
import { useParams } from "react-router";

interface IActivityProps {
  leadId: string;
  documentId: string;
  name?: string;
  stageCode?: string;
  genericProposalDocumentId?: string;
  onUpdate?: () => void;
  onReload?: () => void;
}

export const LeadActivities: React.FunctionComponent<IActivityProps> = (
  props
) => {
  const canCreateLeadActivity = useHasPermission(
    AppPermissions.CreateLeadActivity
  );
  const params = useParams<{ id: string }>();


  const [type, setType] = useState("");
  const [disableTransactionExecutive, setDisableTransactionExecutive] = useState(false);

  const {
    data: plannedActivities,
    reload: reloadPlannedActivities,
  } = useDataLoader<PaginatedApiResponse<ILeadActivity>>(() =>
    api.proposalDocument.getActivities(props.documentId, "planned")
  );

  const {
    data: doneActivities,
    reload: reloadDoneActivities,
    loading,
  } = useDataLoader<PaginatedApiResponse<ILeadActivity>>(
    (tp: string) =>
      api.proposalDocument.getActivities(props.documentId, "completed", {
        type: tp,
      }),
    [type]
  );
  
  const { data: requirementData, loaded, reload } = useDataLoader<LeadRequirement>((requirementId:string) =>
    api.requirement.getRequirement(requirementId || '')
  );

  useEffect(() => {
    const requirementId = params.id;
    const url = window.location.href;
    const containsProposalOrAgreement = url.includes("proposal") || url.includes("agreement");
    if(requirementId && containsProposalOrAgreement){
      reload(requirementId)
      setDisableTransactionExecutive(true)
    }else{
      setDisableTransactionExecutive(false)
    }
  }, [])
  

  React.useEffect(() => {
    if (!loading) {
      reloadDoneActivities(type);
    }
  }, [type]);

  const [tabs, setTabs] = useState<ITabDetail[]>([]);

  useEffect(() => {
    setTabs([
      {
        text: "Note",
        icon: "icon-note",
        isActive: true,
        content: (
          <AddNoteActivity
            leadId={props.leadId!}
            documentId={props.documentId!}
            onSubmitCompleted={() => {
              reloadPlannedActivities();
              reloadDoneActivities(type);
            }}
          ></AddNoteActivity>
        ),
      },
      {
        text: "Activity",
        icon: "icon-activity",
        content: (
          <AddActivityWraper
            leadId={props.leadId}
            documentId={props.documentId!}
            onSubmitCompleted={() => {
              reloadPlannedActivities();
              reloadDoneActivities(type);
            }}
            onSuccess={() => {
              reloadPlannedActivities();
              reloadDoneActivities(type);
            }}
            disableTransactionExecutive={disableTransactionExecutive}
            activity={{
              timePeriod: {
                startDate: new Date(),
                // startTime: "9:00 AM",
                startTime: getNearestFutureTime(moment().format(DateFormats.TimeOnlyFormat), 5),
                endTime: "9:30 AM",
              },
              ...(requirementData?.salesPerson ? { salesPerson: requirementData?.salesPerson as { _id: string; name: string; knownAs?: string }} : {}),
            }}
          ></AddActivityWraper>
        ),
      },
      {
        text: "Files",
        icon: "icon-attach",
        content: (
          <AddFileActivity
            leadId={props.leadId}
            documentId={props.documentId!}
            onSubmitCompleted={() => {
              reloadPlannedActivities();
              reloadDoneActivities(type);
            }}
          ></AddFileActivity>
        ),
      },
    ])
  }, [loaded, requirementData?.salesPerson, disableTransactionExecutive])
  

  return (
    <div className="">
      {canCreateLeadActivity && (
        <div className="bg-white">
          <Tabcontroller
            onChange={(index: number) => {
              const clone = [...tabs];
              clone.forEach((p, i) => {
                i === index ? (p.isActive = true) : (p.isActive = false);
              });
            }}
            tabs={tabs}
          ></Tabcontroller>
        </div>
      )}

      <ul className={`activity-timeline list-unstyled mt-5 px-4 position-relative ${
          plannedActivities?.data?.length === 0 ? "hide-line" : ""
        }`}>
        <PlannedActivities
          activityDetails={plannedActivities}
          onReload={() => {
            props.onReload?.();
            reloadPlannedActivities();
            reloadDoneActivities(type);
          }}
          leadId={props.leadId}
        ></PlannedActivities>
        <DoneActivities
          activityDetails={doneActivities}
          setType={setType}
          type={type}
          leadId={props.leadId}
          genericProposalDocumentId={props?.genericProposalDocumentId}
          stageCode={props?.stageCode}
        ></DoneActivities>
      </ul>
    </div>
  );
};
